import { render } from "./ExpertStatisticsAnswerUnansweredCalls.vue?vue&type=template&id=3fde10f4"
import script from "./ExpertStatisticsAnswerUnansweredCalls.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsAnswerUnansweredCalls.vue?vue&type=script&lang=js"

import "./ExpertStatisticsAnswerUnansweredCalls.vue?vue&type=style&index=0&id=3fde10f4&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__